<div class="container">
  <fa-icon class="loader" [class.shown]="!(atlasFtthFilterService.atlasFtthService.olMapService.filters?.[0]?.choices?.length > 0)" [icon]="icons.falSpinnerThird" animation="spin"></fa-icon>
  @if (atlasFtthFilterService.atlasFtthService.olMapService.filters?.[0]?.choices?.length > 0) {
    <app-area-select
      [(selectedArea)]="selectedArea"
      (selectedAreaChange)="onSearchArea($event)"
    ></app-area-select>
    <div>
      @for (fil of atlasFtthFilterService.atlasFtthService.olMapService.filters; track fil) {
        <app-atlas-filter-field
          [label]="fil.label"
          [value]="atlasFtthFilterService.atlasFtthService.olMapService.filter.get(fil.key)"
          [multiple]="fil.multiple"
          [choices]="fil.choices"
          (valueChange)="setFilter(fil.key, $event)"
        ></app-atlas-filter-field>
      }
    </div>
    <div class="quarter-slider">
      <span>{{ "labels.selectedYear" | translate }}: {{ atlasFtthFilterService.atlasFtthService.layerPostfix }}</span>
      <mat-slider [displayWith]="formatLabel" step="0.25" [min]="Min_Quarter" [max]="max" aria-label="units">
        <input matSliderThumb [(ngModel)]="atlasFtthFilterService.value" (change)="onChangeSlider(atlasFtthFilterService.value)" />
      </mat-slider>
    </div>
  }
</div>